/* tslint:disable */
/* eslint-disable */
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AccessRolePermissionOverride
 */
export interface AccessRolePermissionOverride {
    /**
     * 
     * @type {string}
     * @memberof AccessRolePermissionOverride
     */
    permission: AccessRolePermissionOverridePermissionEnum;
    /**
     * 
     * @type {string}
     * @memberof AccessRolePermissionOverride
     */
    scope: AccessRolePermissionOverrideScopeEnum;
    /**
     * 
     * @type {Array<number>}
     * @memberof AccessRolePermissionOverride
     */
    employeeIds?: Array<number>;
}

/**
* @export
* @enum {string}
*/
export enum AccessRolePermissionOverridePermissionEnum {
    ManageEmployeePay = 'ManageEmployeePay',
    ViewEmployeeCosts = 'ViewEmployeeCosts',
    ViewLabourCosts = 'ViewLabourCosts'
}
/**
* @export
* @enum {string}
*/
export enum AccessRolePermissionOverrideScopeEnum {
    None = 'None',
    All = 'All',
    LineManagees = 'LineManagees',
    Custom = 'Custom'
}


/**
 * Check if a given object implements the AccessRolePermissionOverride interface.
 */
export function instanceOfAccessRolePermissionOverride(value: object): value is AccessRolePermissionOverride {
    if (!('permission' in value) || value['permission'] === undefined) return false;
    if (!('scope' in value) || value['scope'] === undefined) return false;
    return true;
}

export function AccessRolePermissionOverrideFromJSON(json: any): AccessRolePermissionOverride {
    return AccessRolePermissionOverrideFromJSONTyped(json, false);
}

export function AccessRolePermissionOverrideFromJSONTyped(json: any, ignoreDiscriminator: boolean): AccessRolePermissionOverride {
    if (json == null) {
        return json;
    }
    return {
        
        'permission': json['permission'],
        'scope': json['scope'],
        'employeeIds': json['employeeIds'] == null ? undefined : json['employeeIds'],
    };
}

  export function AccessRolePermissionOverrideToJSON(json: any): AccessRolePermissionOverride {
      return AccessRolePermissionOverrideToJSONTyped(json, false);
  }

  export function AccessRolePermissionOverrideToJSONTyped(value?: AccessRolePermissionOverride | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'permission': value['permission'],
        'scope': value['scope'],
        'employeeIds': value['employeeIds'],
    };
}

